import classnames from 'classnames';
import React from 'react';
import type { Moment } from 'moment';
import { MomentTimePicker } from './momentDatePicker';

export type TimePickerInputProps = {
  className?: string;
  label?: string;
  value?: Moment;
  isError?: boolean;
  errorMessage?: string;
  onChange: (value: Moment | null, dateString: string | string[]) => void;
  format?: string;
  placeholder?: string;
  // used in JSX below but never declared in the original PropTypes
  disabled?: boolean;
};

const TimePickerInput = ({
  className,
  label = '',
  value,
  isError = false,
  errorMessage = '',
  format = 'HH:mm',
  placeholder = '',
  onChange,
  disabled,
}: TimePickerInputProps) => (
  <div className={classnames('custom-time-picker-input', className)}>
    {!!label && <div className="custom-time-picker-input__label">{label}</div>}
    <MomentTimePicker
      className={classnames('custom-time-picker-input__calendar-picker', isError ? '--error' : '')}
      format={format}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
    />
    {isError && !!errorMessage && (
      <div className="custom-time-picker-input__error-message">{errorMessage}</div>
    )}
  </div>
);

export default TimePickerInput;
